export class Response {
    public text: string;
    public points: number;
}

/**
 * Represents one interaction between the student and AlienPatron
 * Alien asks a question, student has two possible responses
 */
export class AlienStudentInteraction {
    public alienQuestion: string;
    public responses: Response[];
}

/**
 * Represents an AlienPatron's dialog with the student (sequence of interactions)
 */
export class Dialog {
    public interactions: AlienStudentInteraction[];

    private translateString = "HotelAurora.Phaser.AlienStudentInteractions.";

    /**
     * AnswerPatronQuestionScene translates using these keys
     */

    constructor() {
        this.interactions = [
            {
                alienQuestion: this.translateString + "1.alienQuestion",
                responses: [
                    {
                        text: this.translateString + "1.responses.1",
                        points: 2,
                    },
                    {
                        text: this.translateString + "1.responses.2",
                        points: 1,
                    },
                    {
                        text: this.translateString + "1.responses.3",
                        points: -1,
                    }
                ]
            },
            {
                alienQuestion: this.translateString + "2.alienQuestion",
                responses: [
                    {
                        text: this.translateString + "2.responses.1",
                        points: -1,
                    },
                    {
                        text: this.translateString + "2.responses.2",
                        points: 1,
                    },
                    {
                        text: this.translateString + "2.responses.3",
                        points: 2,
                    }
                ]
            },
            {
                alienQuestion: this.translateString + "3.alienQuestion",
                responses: [
                    {
                        text: this.translateString + "3.responses.1",
                        points: 1,
                    },
                    {
                        text: this.translateString + "3.responses.2",
                        points: 2,
                    },
                    {
                        text: this.translateString + "3.responses.3",
                        points: -1,
                    }
                ]
            },
            {
                alienQuestion: this.translateString + "4.alienQuestion",
                responses: [
                    {
                        text: this.translateString + "4.responses.1",
                        points: 2,
                    },
                    {
                        text: this.translateString + "4.responses.2",
                        points: 0,
                    },
                    {
                        text: this.translateString + "4.responses.3",
                        points: -1,
                    }
                ]
            },
            {
                alienQuestion: this.translateString + "5.alienQuestion",
                responses: [
                    {
                        text: this.translateString + "5.responses.1",
                        points: 1,
                    },
                    {
                        text: this.translateString + "5.responses.2",
                        points: -1,
                    },
                    {
                        text: this.translateString + "5.responses.3",
                        points: 2,
                    }
                ]
            },
            {
                alienQuestion: this.translateString + "6.alienQuestion",
                responses: [
                    {
                        text: this.translateString + "6.responses.1",
                        points: 2,
                    },
                    {
                        text: this.translateString + "6.responses.2",
                        points: -1,
                    },
                    {
                        text: this.translateString + "6.responses.3",
                        points: 0,
                    }
                ]
            }
        ];
    }
}

export class AlienPatron {
    public id: number;
    public assetKey: string;
    public object: Phaser.GameObjects.Image;
    public dialog: Dialog;

    constructor(id: number, assetKey: string) {
        this.id = id;
        this.assetKey = assetKey;
        this.object = null;
        this.dialog = new Dialog();
    }

    public static ALL_PATRONS: AlienPatron[] = [
        new AlienPatron(1, "alien_1"),
        new AlienPatron(2, "alien_2"),
        new AlienPatron(3, "alien_3"),
    ];
}



// WEBPACK FOOTER //
// ./src/games/HotelAuroraGame/objects/AlienPatron.ts